import { getLocalVariable, removeLocalVariable, setSessionVariable } from '@services/storage';

import { IRudiApiRechercherAdresse } from '@app-types/eligibility';

export function getStoredGcpData(): IRudiApiRechercherAdresse {
    return JSON.parse(getLocalVariable('eligibility_gcp_data') ?? '{}');
}

export function removeStoredGcpData() {
    removeLocalVariable('eligibility_gcp_data');
}

export function setThreeClicsStorage(active: boolean) {
    setSessionVariable('ftth3Clics', JSON.stringify({ data: active }));
}

export function setMixedCartStorage(active: boolean) {
    setSessionVariable('panierMixte', JSON.stringify({ data: active }));
}
